import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Layout } from '../components/Layout';
import { Loader2 } from 'lucide-react';

export const MyAccount = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Wait for auth to load, then redirect to advertiser detail page
    if (!loading && user?.advertiser_id) {
      navigate(`/advertisers/${user.advertiser_id}`, { replace: true });
    }
  }, [user, loading, navigate]);

  // Show loading while redirecting
  return (
    <Layout>
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin mx-auto text-slate-400" />
          <p className="mt-4 text-slate-600">Loading your account...</p>
        </div>
      </div>
    </Layout>
  );
};
